import z from "zod";

/**
 * InspecaoObraItemSchema
 */

export const InspecaoObraItemSchema = z.object({
  idInspecaoObraItem: z.number(),
  descricao: z.string().nullable(),
  metodoVerificacao: z.string().nullable().default(null),
  tolerancia: z.string().nullable().default(null),
  inspecao1: z.string().default(""),
  dataInspecao1: z.coerce.date().nullable().default(null),
  inspecao2: z.string().default(""),
  dataInspecao2: z.coerce.date().nullable().default(null),
  usuarioRegistradoPorInspecao1: z.string().nullable().default(null),
  usuarioRegistradoPorInspecao2: z.string().nullable().default(null),
  dataRegistradoPorInspecao1: z.coerce.date().nullable().default(null),
  dataRegistradoPorInspecao2: z.coerce.date().nullable().default(null),
});

/**
 * InspecaoObraItemForm
 */

export type InspecaoObraItemForm = z.infer<typeof InspecaoObraItemSchema>;

/**
 * InspecaoObraVerificacaoSchema
 */

export const InspecaoObraVerificacaoSchema = z.object({
  funcionarioAprovacaoFinal: z.string().nullable().default(null),
  dataAprovacaoFinal: z.coerce.date().nullable().default(null),
  filtrarFuncionariosPorCentroCusto: z.coerce.boolean().default(true),
  idFuncionarioInspecionado: z.coerce.number({ required_error: 'Este campo deve ser preenchido!', invalid_type_error: 'Este campo deve ser preenchido!' }),
  idFuncionarioAprovado: z.coerce.number().nullable().default(null),
  status: z.coerce.number().default(0),
  dataEncerramento: z.coerce.date().nullable().default(null),
  observacao: z.string().nullable().default(null),
  arquivo1: z.instanceof(File).nullable().default(null),
  limparArquivo1: z.boolean().default(false),
  arquivo2: z.instanceof(File).nullable().default(null),
  limparArquivo2: z.boolean().default(false),
  arquivo3: z.instanceof(File).nullable().default(null),
  limparArquivo3: z.boolean().default(false),
  arquivo4: z.instanceof(File).nullable().default(null),
  limparArquivo4: z.boolean().default(false),
  arquivo5: z.instanceof(File).nullable().default(null),
  limparArquivo5: z.boolean().default(false),
  inspecaoObraItens: z.array(InspecaoObraItemSchema).default([]),
  path: z.array(z.string()).optional(),
  descricaoArquivo1: z.string().nullable().default(null),
  descricaoArquivo2: z.string().nullable().default(null),
  descricaoArquivo3: z.string().nullable().default(null),
  descricaoArquivo4: z.string().nullable().default(null),
  descricaoArquivo5: z.string().nullable().default(null),
});

/**
 * InspecaoObraVerificacaoForm
 */

export type InspecaoObraVerificacaoForm = z.infer<typeof InspecaoObraVerificacaoSchema>;
